import React, { useEffect } from 'react';
import { getEnv } from '@config';
import { usePromotions, useScript } from '@hooks';
import { AppLoader } from '@components/AppLoader';

export const FalabellaSellerCl = () => {
  const { sellerCreditFacilityUrl } = getEnv();
  useScript(sellerCreditFacilityUrl, 'module');

  const {
    tokenForCreditLineWidget,
    getTokenForCreditLineWidget,
    isCreditLineTokenLoading,
    setTokenForCreditLineLoading,
  } = usePromotions();

  useEffect(() => {
    getTokenForCreditLineWidget();
    return () => {
      setTokenForCreditLineLoading();
    };
  }, [getTokenForCreditLineWidget, setTokenForCreditLineLoading]);

  return (
    <>
      {isCreditLineTokenLoading ? (
        <AppLoader />
      ) : (
        <falabella-seller-credits
          token={tokenForCreditLineWidget}
          data-testId="finance-datamart-widget"
        />
      )}
    </>
  );
};

export default FalabellaSellerCl;
